var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreeceFlagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-4 -3H28V21H-4V-3Z",
    fill: "#F7FCFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 15.9004H-4V12.9434H28V15.9004ZM28 10.7725H-4V7.81543H28V10.7725ZM28 5.45703H-4V2.5H28V5.45703Z",
    fill: "#4564F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-4 -3H11V10.8H-4V-3Z",
    fill: "#4564F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 -3H5V2.50386H11V5.43867H5V11.5H2V5.43867H-4V2.50386H2V-3Z",
    fill: "#F7FCFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreeceFlagIcon);
export default __webpack_public_path__ + "static/media/greeceFlagIcon.cb2f18151279c81370486039067449ad.svg";
export { ForwardRef as ReactComponent };